import { IndexStore } from 'store/Index/store';
import { UUID } from 'store/types';

export const getMetricLabel = (metricName: string, uuid: UUID, indexStore: IndexStore) => {
  const index = indexStore[uuid];

  if (index) {
    if (metricName === index.plotMetric) {
      return 'Index Level';
    }
  }
  return metricName.replaceAll('_', ' ');
};
